<template>
  <div class="pattern" :class="[loading?'loading':'',isSelected?'selected':'']">
    <figure>
      <template v-if="!skeleton">
        <aside @click.stop="openPreview">
          <span>{{ $t('pattern.view') }} </span>
        </aside>
      </template>
      <template v-if="loading || skeleton">
        <img alt="" src="data:image/png;base64,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"/>
      </template>
      <template v-else>
        <img
            v-lazyload :src="pattern.image">
      </template>
    </figure>

    <address>
      <aside>
        <template v-if="loading || skeleton">
          <img alt=""
               src="data:image/png;base64,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"/>
        </template>
        <template v-else>
          <img
                v-lazyload :src="pattern.owner_avatar">
        </template>
      </aside>
      <main>
        <template v-if="loading || skeleton">
        <span>Loading</span>
        <strong>Loading Owner</strong>
        </template>
        <template v-else>
          <span>{{ pattern.title ? pattern.title:'' }}</span>
          <strong>{{ pattern.owner ? pattern.owner : '' }}</strong>
        </template>
      </main>
    </address>
  </div>
</template>

<script>


export default {
  name: 'thumb',
  props: {
    skeleton: {
      type: Boolean,
      default: false
    },
    pattern:{
      type: Object
    }
  },
  computed: {
    loading() {
      return this.$store.state.loading
    },
    emptyImage() {
      return this.placeholder;
    },
    isSelected() {


      if (this.pattern && this.pattern.id ) {
        let _selected = this.$store.getters.getSelected;
        if (_selected.id) {
          return (_selected.id === this.pattern.id);
        }
      }
      return false;
    }
  },
  methods: {
    openPreview() {
      this.$store.dispatch('setPreview', this.pattern);
    }
  }
}
</script>
<style>

.pattern {

}

.pattern.loading figure,
.pattern.loading aside {
  @apply bg-gray-300 animate-pulse text-gray-300 rounded;
}

.pattern.loading address span,
.pattern.loading address strong {
  @apply bg-gray-300 animate-pulse text-gray-300 my-0.5 rounded;
}


.pattern figure {
  @apply text-gray-300 rounded overflow-hidden bg-gray-50 relative cursor-pointer border-4 bg-gray-100 border-gray-100 border-opacity-0 overflow-hidden;
  width: var(--pattern-thumbnail);
  height: var(--pattern-thumbnail);
}

.pattern figure:hover aside {
  @apply flex;
}

.pattern figure img{
  @apply rounded bg-gray-300;
}
.pattern figure aside {
  @apply hidden font-bold text-white w-full absolute h-full bg-opacity-70 bg-gray-400 rounded flex items-center justify-center shadow;
}

.pattern.selected figure {
  @apply border-primary relative text-white;
}

.pattern.selected figure:before {
  @apply block w-10 h-10 transform rotate-45 absolute z-10 bg-primary -mr-5 -mt-5 right-0 top-0;
  content: "";
}

.pattern.selected figure:after {
  @apply block  w-4 h-4 absolute z-10  -mr-0.5 -mt-0.5 right-0 top-0;
  content: url("data:image/svg+xml; utf8, <svg class=\"text-white\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"white\"> <path fill-rule=\"evenodd\" d=\"M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z\" clip-rule=\"evenodd\" /> </svg>");
}

.pattern.selected figure img{
  @apply rounded-none
}

.pattern address {
  @apply not-italic flex flex-row my-5 text-base items-center justify-start ;
}

.pattern address aside {
  @apply flex flex-shrink-0 flex-grow-0 mr-2 text-gray-300;
}

.pattern address aside img {
  @apply rounded-full h-10 w-10 object-cover object-center;
}

.pattern address main {
  @apply block truncate overflow-ellipsis leading-tight;
  min-width: 0;
  box-sizing: border-box;
}

.pattern address main span {
  @apply block font-normal whitespace-nowrap overflow-hidden overflow-ellipsis text-gray-700;
}

.pattern address main strong {
  @apply text-gray-500 font-normal whitespace-nowrap overflow-hidden overflow-ellipsis truncate;
}


</style>